import {Controller} from "stimulus"

let draggable
let ghostElement

export default class extends Controller {
    static values = {selfScheduling: Boolean}

    connect() {
        this.selfScheduling = this.hasSelfSchedulingValue ? this.selfSchedulingValue : (this.element.dataset.selfScheduling === "true")
        const storedNotice = sessionStorage.getItem("inspectionNotice");
        if (storedNotice) {
            showNotice(storedNotice);
            sessionStorage.removeItem("inspectionNotice");
        }
    }

    updateReport(e) {
        const reportDate = document.getElementById("for_date")
        window.location.href = '?for_date=' + reportDate.value;
    }

    dragInspection(e) {
        e.target.classList.add("opacity-30")
        draggable = e.target
    }

    touchInspection(e) {
        e.preventDefault();
        draggable = e.target.closest(".inspection-visit")
        // Create ghost element
        ghostElement = draggable.cloneNode(true);
        ghostElement.classList.add("opacity-50", "fixed", "pointer-events-none", "z-50");
        document.body.appendChild(ghostElement);

        const touch = e.touches[0];
        ghostElement.style.left = (touch.clientX - 5) + 'px';
        ghostElement.style.top = (touch.clientY - ghostElement.offsetHeight / 2) + 'px';

        document.addEventListener('touchmove', handleTouchMove);
    }

    dragStopInspection(e) {
        e.target.classList.remove("opacity-30")
        document.removeEventListener('touchmove', handleTouchMove);

        if (ghostElement) {
            ghostElement.remove();
            ghostElement = null;
        }
    }

    onAssignable(e) {
        e.preventDefault();
        return true;
    }

    visitAssignable(e) {
        e.target.classList.add("animate-pulse")
        setTimeout(function () {
            e.target.classList.remove("animate-pulse");
        }, 3000);
        return true;
    }

    leaveAssignable(e) {
        e.target.classList.remove("animate-pulse")
    }

    assignTouchedInspection(e) {
        e.preventDefault();
        const touch = e.changedTouches[0];
        const lastTouchedElement = document.elementFromPoint(touch.clientX, touch.clientY);
        document.removeEventListener('touchmove', handleTouchMove);

        if (ghostElement) {
            ghostElement.remove();
            ghostElement = null;
        }

        if (lastTouchedElement.dataset.status) {
            const status = lastTouchedElement.dataset.status;
            const inspectionId = draggable.dataset.inspectionId;
            const inspectionVisitId = draggable.dataset.inspectionVisitId;

            if (status === 'cancelled') {
                showNotice('Inspection has been cancelled');
            } else if (status === 'rescheduled') {
                showNotice('Inspection has been marked for rescheduling');
            }

            updateInspectionTimeSlot(null, inspectionId, inspectionVisitId, status, draggable);
            draggable.classList.add("opacity-60", "resolved-attempt");
            return;
        }

        if (lastTouchedElement.closest(".timeslot")) {
            lastTouchedElement.closest(".timeslot").querySelector(".inspections-area").prepend(draggable);
            const timeSlotArea = lastTouchedElement.closest(".timeslot")
            const timeslot = timeSlotArea.dataset.time;
            const inspectionId = draggable.dataset.inspectionId;
            const inspectionVisitId = draggable.dataset.inspectionVisitId;
            updateInspectionTimeSlot(timeslot, inspectionId, inspectionVisitId, null, draggable, timeSlotArea);
            draggable.classList.remove("opacity-30");
            draggable.classList.add("animate-pulse");
            setTimeout(function () {
                draggable.classList.remove("animate-pulse");
            }, 1000);
        }
    }

    assignInspection(e) {
        e.preventDefault();
        const timeslotArea = e.target.closest(".timeslot");
        const timeslot = timeslotArea.dataset.time;
        const inspectionId = draggable.dataset.inspectionId;
        const inspectionVisitId = draggable.dataset.inspectionVisitId;
        updateInspectionTimeSlot(timeslot, inspectionId, inspectionVisitId, null, draggable, timeslotArea);
        e.target.closest(".timeslot").querySelector(".inspections-area").prepend(draggable);
        draggable.classList.remove("opacity-30");
        draggable.classList.add("animate-pulse");
        setTimeout(function () {
            draggable.classList.remove("animate-pulse");
        }, 1000);
    }

    handleStatusDrop(e) {
        e.preventDefault();

        let targetElement;
        if (e.type === 'touchend') {
            const touch = e.changedTouches[0];
            targetElement = document.elementFromPoint(touch.clientX, touch.clientY);
        } else {
            targetElement = e.target;
        }

        const status = targetElement.dataset.status;
        const inspectionId = draggable.dataset.inspectionId;
        const inspectionVisitId = draggable.dataset.inspectionVisitId;
        const currentScheduled = draggable ? draggable.dataset.scheduledFor : null;

        let replacementScheduledFor = null;
        let unscheduledReplacement = false;
        let selfScheduleRedirect = false;

        if (status === 'rescheduled') {
            if (this.selfScheduling) {
                replacementScheduledFor = currentScheduled || null;
                selfScheduleRedirect = true;
            } else {
                unscheduledReplacement = true;
            }
        }

        if (status === 'cancelled') {
            showNotice('Inspection has been cancelled');
        } else if (status === 'rescheduled') {
            showNotice('Inspection has been marked for rescheduling');
        }

        updateInspectionTimeSlot(null, inspectionId, inspectionVisitId, status, draggable, null, replacementScheduledFor, unscheduledReplacement, selfScheduleRedirect);
        draggable.classList.add("opacity-60", "resolved-attempt");
    }
}

function updateInspectionTimeSlot(timeslot, inspectionId, inspectionVisitId, status = null, inspectionElement, timeslotArea, replacementScheduledFor = null, unscheduledReplacement = false, selfScheduleRedirect = false) {
    let relatedVisitIds = [];
    let url = '/inspections/' + inspectionId + '/inspection_visits/' + inspectionVisitId + '.json';
    if (inspectionElement && inspectionElement.dataset.relatedVisitIds) {
        try {
            relatedVisitIds = JSON.parse(inspectionElement.dataset.relatedVisitIds);
        } catch (e) {
            relatedVisitIds = inspectionElement.dataset.relatedVisitIds.split(',').map(id => id.trim()).filter(Boolean);
        }
    }
    const currentScheduled = inspectionElement ? inspectionElement.dataset.scheduledFor : null;
    let assignRelated = false;
    if (relatedVisitIds.length > 0) {
        assignRelated = window.confirm(
            `This visit is related to ${relatedVisitIds.length} others.\nAssign all to this inspector as well?`
        );
    }

    if (status) {
        url += '?visit_action=' + status;
    }
    const payload = {
        related_visit_ids: assignRelated ? relatedVisitIds : []
    }
    if (timeslot) {
        payload.scheduled_for = timeslot
    } else if (currentScheduled) {
        payload.scheduled_for = currentScheduled
    }
    if (replacementScheduledFor) {
        payload.replacement_visit = {scheduled_for: replacementScheduledFor}
    }
    if (unscheduledReplacement) {
        payload.unscheduled_replacement = true
    }
    if (selfScheduleRedirect) {
        payload.self_schedule_redirect = true
    }

    fetch(url, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify(payload)
    }).then(response => response.json())
        .then(data => {
            if (status && inspectionElement) {
                inspectionElement.classList.add("opacity-60", "resolved-attempt");
            }
            const timeSlotDropZone = timeslotArea ? timeslotArea.querySelector(".inspections-area") : null
            if (assignRelated && relatedVisitIds.length > 0 && timeSlotDropZone) {
                relatedVisitIds.forEach(id => {
                    const relatedEl = document.querySelector(`.inspection-visit[data-inspection-visit-id='${id}']`);
                    if (timeSlotDropZone && relatedEl) {
                        timeSlotDropZone.prepend(relatedEl);
                        relatedEl.classList.add("animate-pulse");
                        setTimeout(() => {
                            relatedEl.classList.remove("animate-pulse");
                        }, 1000);
                    }
                });
            }

            if (data.notice) {
                sessionStorage.setItem("inspectionNotice", data.notice);
            }
            if (data.redirect_url) {
                window.location.href = data.redirect_url;
                return;
            }
            if (status) {
                window.location.reload();
                return
            }
            document.querySelectorAll(".inspector-column").forEach((inspector) => {
                const count = inspector.querySelectorAll(".inspection-visit").length;
                inspector.querySelector(".inspector-count").innerHTML = count;
            });
        });
}

function handleTouchMove(e) {
    const touch = e.touches[0];

    if (ghostElement) {
        ghostElement.style.left = (touch.clientX - 5) + 'px';
        ghostElement.style.top = (touch.clientY - ghostElement.offsetHeight / 2) + 'px';
    }

    const viewportHeight = window.innerHeight;
    const scrollTriggerDistance = 100;

    if (touch.clientY > viewportHeight - scrollTriggerDistance) {
        window.scrollBy(0, 10);
    }

    if (touch.clientY < scrollTriggerDistance) {
        window.scrollBy(0, -10);
    }
}

function showNotice(text) {
    if (!text) return;
    const flashArea = document.getElementById('flash-area');
    if (!flashArea) return;
    const flashMessage = document.createElement('div');
    flashMessage.className = 'notice';
    flashMessage.textContent = text;
    flashArea.appendChild(flashMessage);
    setTimeout(() => {
        flashMessage.remove();
    }, 3000);
}
